module.exports = __webpack_public_path__ + "img/telenor-logo-flat-white.5b0d6d87.svg";